module.exports = __webpack_public_path__ + "static/media/logo.62718d22.svg";